module.exports = __webpack_public_path__ + "img/12.a14d68f0.webp";